import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import {
  IState,
  ISuccessAction,
  IFailureAction,
  IDeleteRequest,
} from 'interfaces/delete-duck';

const { Types, Creators } = createActions(
  {
    request: ['userId', 'regionalId', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'DELETE_USER_REGIONAL_' }
);

export interface DeleteUserRegionalState extends IState {}

export interface DeleteUserRegionalRequest extends IDeleteRequest {
  userId: number;
  regionalId: number;
}
const INITIAL_STATE: DeleteUserRegionalState = {
  loading: false,
  error: null,
};

const request = (state: DeleteUserRegionalState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: DeleteUserRegionalState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: DeleteUserRegionalState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const deleteUserRegional = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const DeleteUserRegionalTypes = Types;
export const DeleteUserRegionalActions = Creators;
